import { NavLink } from 'react-router';
import type { ObjectIcon } from '../../ui';
import { NavCount } from './NavCount';
import { NavIcon } from './NavIcon';
import { navItem } from './navItem';

/**
 * BEN'S THREE SCREENS AT THE TOP OF THE SIDEBAR, WITH NO HEADING (redesign register A5-4:
 * "Dashboard, Onboarding, Clients, then My tasks and Reports as a second short block (no
 * headings)"; H1: the Dashboard is the start page at `/`, so its row leads there and is the
 * selected row on the start page). The same rows the object list draws - `navItem` for the
 * selection, hover and press, `NavIcon` for the symbol - so nothing about them is a second
 * construction.
 *
 * IT IS NOT AN OBJECT LIST, so neither of the object list's two person-controlled rules applies:
 * it has no "Hide from Sidebar" and it does not fold. It is always there.
 *
 * THE SYMBOLS: Dashboard takes `dashboard` and Onboarding the `tasks` checklist; Clients takes
 * its own `clients`, our drawing of Apple's person.2.circle.fill (register A8-1 b, 5 Oct 2026),
 * so it no longer shares the Agencies object's `agency` (DESIGN.md E6, one symbol per destination).
 */
export const FULFILLMENT_ROWS: readonly {
  readonly to: string;
  readonly label: string;
  readonly icon: ObjectIcon;
  readonly count?: 'onboarding' | 'clients';
}[] = [
  { to: '/', label: 'Dashboard', icon: 'dashboard' },
  { to: '/fulfillment/onboarding', label: 'Onboarding', icon: 'tasks', count: 'onboarding' },
  { to: '/fulfillment/clients', label: 'Clients', icon: 'clients', count: 'clients' },
];

export function FulfillmentNav({
  onNavigate,
  counts,
}: {
  readonly onNavigate?: () => void;
  /**
   * The desktop sidebar's counts (register R-S2). The phone's Data screen passes none: it keeps
   * today's rows until the phone round (P6).
   */
  readonly counts?: { readonly onboarding: number | null; readonly clients: number | null };
}) {
  return (
    <ul>
      {FULFILLMENT_ROWS.map((row) => (
        <li key={row.to}>
          {/* `end` on `/`: every path starts with it, and only the start page is the Dashboard. */}
          <NavLink to={row.to} end={row.to === '/'} onClick={onNavigate} className={navItem}>
            <NavIcon icon={row.icon} />
            <span className="flex-1 truncate">{row.label}</span>
            {row.count !== undefined && counts !== undefined && (
              <NavCount value={counts[row.count]} />
            )}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
